import {JsToClientCommand} from '../jsToClientCommand';
import {ClientCommands} from '../clientCommands';

export type PayFinishParams = {
    status: number,
    last_payment?: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbError?: any
};


export class PayFinishCommand extends JsToClientCommand<PayFinishParams> {
    constructor(params: PayFinishParams) {
        super(ClientCommands.PAY_FINISH, params);
    }
}
